module.exports = __webpack_public_path__ + "static/media/C-100HD_CrossSection.f0e2bde5.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/fr/C-100HD_CrossSection.png
// module id = 490
// module chunks = 0